import { ProductType } from '@/types';

export const getAvailableAppearances = (productType: ProductType) =>
  productType !== null
    ? productType.appearances.filter((a) =>
        productType.stockStates.some((s) => s.appearance.id === a.id && s.available)
      )
    : [];
